import React, { useState, useRef } from "react";
import { useStyles } from "./otpScreen.styles";
import { Box, Button, Grid, Typography } from "@material-ui/core";
import { TextConstants } from "constants/TextConstants";

interface OtpPopupProps {
  isOpen: boolean;
  onSubmit: (otp: string) => void;
  numDigits?: number;
}

const OtpScreen: React.FC<OtpPopupProps> = ({
  isOpen,
  onSubmit,
  numDigits = 6,
}) => {
  const classes = useStyles();
  const [otp, setOtp] = useState(Array(numDigits).fill(""));

  const inputRefs = useRef<(HTMLInputElement | null)[]>([]);

  // Handle input change
  const handleChange = (index: number, value: string) => {
    if (/^[0-9]$/.test(value) || value === "") {
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);

      // Move to next input if a digit is entered
      if (value && index < numDigits - 1) {
        inputRefs.current[index + 1]?.focus();
      }
    }
  };

  // Handle backspace
  const handleKeyDown = (
    index: number,
    e: React.KeyboardEvent<HTMLInputElement>
  ) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      inputRefs.current[index - 1]?.focus();
    }
  };

  // Handle form submission
  const handleSubmit = () => {
    const otpValue = otp.join("");
    if (otpValue.length === numDigits) {
      onSubmit(otpValue); // Pass OTP to parent component
      setOtp(Array(numDigits).fill("")); // Reset OTP
    }
  };

  if (!isOpen) return null;

  return (
    <>
      <Grid className={classes.otpRoot}>
        <Typography className="heading" gutterBottom>
          {TextConstants.SET_UP_ACCOUNT}
        </Typography>
        <Typography className="subHeading" gutterBottom>
          {TextConstants.OTP_INFO} {numDigits}
          {TextConstants.OTP_INFO2}
        </Typography>
        <Typography className="subtitle1">
          {TextConstants.CONFIRMATION_CODE}
        </Typography>
        <Box className={classes.otpInputs}>
          {otp.map((digit, index) => (
            <input
              key={index}
              type="text"
              maxLength={1}
              value={digit}
              onChange={(e) => handleChange(index, e.target.value)}
              onKeyDown={(e) => handleKeyDown(index, e)}
              ref={(el) => (inputRefs.current[index] = el)}
            />
          ))}
        </Box>
      </Grid>
      <Button
        onClick={handleSubmit}
        disabled={otp.join("").length !== numDigits}
        className={classes.continueBtn}
      >
        {TextConstants.CONTINUE}
      </Button>
    </>
  );
};

export default OtpScreen;
